module.exports = __webpack_public_path__ + "static/media/leading-leg-right.f3ab8cea.svg";